import { Component, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogHtml, MessageService } from "common";
import { AnnouncementData, AnnouncementButtonActionType, AnnouncementType } from "../../announcement/announcement.model";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Clipboard } from "@angular/cdk/clipboard";
import { Router } from "@angular/router";

@UntilDestroy()
@Component({
    selector: "ifp-announcement-widget",
    templateUrl: "./announcement-widget.component.html",
    styleUrls: ["./announcement-widget.component.scss"],
    standalone: false
})
export class AnnouncementWidgetComponent {
  @Input() announcement: AnnouncementData;

  readonly AnnouncementType = AnnouncementType;
  readonly AnnouncementButtonActionType = AnnouncementButtonActionType;

  constructor(
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private router: Router,
    private messageService: MessageService
  ) {}

  handleButtonClick(actionType: AnnouncementButtonActionType, payload: string): void {
    switch (actionType) {
      case AnnouncementButtonActionType.ReadMore:
        this.showMoreInfo();
        break;
      case AnnouncementButtonActionType.Copy:
        this.copyToClipboard(payload);
        break;
      case AnnouncementButtonActionType.LinkInternal:
        this.handleInternalLink(payload);
        break;
      case AnnouncementButtonActionType.LinkExternal:
        this.handleExternalLink(payload);
        break;
  
      default:
        console.warn("Unknown button action type:", actionType);
    }
  }

  showMoreInfo(): void {
    this.dialog.open(DialogHtml, {
      width: "600px",
      closeOnNavigation: true,
      data: { message: this.announcement.moreInfo },
    });
  }

  copyToClipboard(text: string): void {
    const success = this.clipboard.copy(text);
    if (success) {
      this.messageService.info("Copied to clipboard");
    } else {
      this.messageService.error("Failed to copy");
    }
  }

  handleInternalLink(route: string): void {
    this.router.navigate([route]);
  }

  handleExternalLink(url: string): void {
    window.open(url, '_blank');
  }
}
